import { Firestore } from "firebase/firestore";
import { Functions } from "firebase/functions";
import { FirebaseStorage } from "firebase/storage";
import React, { createContext, useContext, useMemo } from "react";
import { db, functions, storage } from "src/firebase";

// Define the context type
export type Clients = {
  db: Firestore;
  storage: FirebaseStorage;
  functions: Functions;
};

export type Context = {
  clients: Clients;
};

// Create stable client instances - imported from src/firebase to ensure
// Firestore is initialized with correct options (ignoreUndefinedProperties)
const stableClients: Clients = {
  db,
  storage,
  functions,
};

// Create the initial context value
const initialContextValue: Context = {
  clients: stableClients,
};

// Create the app context
export const AppContext = createContext<Context>(initialContextValue);

export const useAppContext = () => useContext(AppContext);

// Create the provider component
interface AppContextProviderProps {
  children: React.ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
}) => {
  const contextValue = useMemo(() => initialContextValue, []);

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};
